"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tfjs_1 = require("@tensorflow/tfjs");

var utils_1 = require("./utils");

function arrayStats(input) {
  if (!Array.isArray(input)) {
    throw new Error('input must be an array');
  }

  if (input.length === 0) {
    return {
      numVals: 0,
      numNans: 0,
      numZeros: 0,
      max: undefined,
      min: undefined
    };
  }

  var numVals = input.length;
  var max = -Infinity;
  var min = Infinity;
  var numZeros = 0;
  var numNans = 0;
  var numInfs = 0;

  for (var i = 0; i < numVals; i++) {
    var curr = input[i];

    if (curr > max) {
      max = curr;
    }

    if (curr < min) {
      min = curr;
    }

    if (curr === 0) {
      numZeros += 1;
    }

    if (isNaN(curr)) {
      numNans += 1;
    } else if (!isFinite(curr)) {
      numInfs += 1;
    }
  }

  var result = {
    numVals: numVals,
    numZeros: numZeros,
    numNans: numNans,
    max: max,
    min: min,
    numInfs: numInfs
  };

  if (result.max === -Infinity) {
    result.max = NaN;
  }

  if (result.min === Infinity) {
    result.min = NaN;
  }

  return result;
}

exports.arrayStats = arrayStats;

function tensorStats(input) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _tfjs_1$tidy, _tfjs_1$tidy2, min, max, numZeros;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _tfjs_1$tidy = tfjs_1.tidy(function () {
              var zero = tfjs_1.scalar(0, input.dtype);
              var min = input.min();
              var max = input.max();
              var numZeros = input.equal(zero).sum();
              return [min, max, numZeros];
            }), _tfjs_1$tidy2 = _slicedToArray(_tfjs_1$tidy, 3), min = _tfjs_1$tidy2[0], max = _tfjs_1$tidy2[1], numZeros = _tfjs_1$tidy2[2];
            _context.next = 3;
            return Promise.all([input.data(), min.data(), max.data(), numZeros.data()]).then(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 4),
                  tensorVal = _ref2[0],
                  minVal = _ref2[1],
                  maxVal = _ref2[2],
                  numZerosVal = _ref2[3];

              var numVals = tensorVal.length;
              var numNans = 0;
              var numInfs = 0;

              for (var i = 0; i < numVals; i++) {
                var curr = tensorVal[i];

                if (isNaN(curr)) {
                  numNans += 1;
                } else if (!isFinite(curr)) {
                  numInfs += 1;
                }
              }

              var trueMin = minVal[0];
              var trueMax = maxVal[0];

              if (numNans === numVals) {
                trueMin = NaN;
                trueMax = NaN;
              }

              var stats = {
                numVals: numVals,
                numZeros: numZerosVal[0],
                numNans: numNans,
                min: trueMin,
                max: trueMax,
                numInfs: numInfs
              };
              return stats;
            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.tensorStats = tensorStats;

function confusionMatrix(labels, predictions, numClasses, weights) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var labelsInt, predictionsInt, weightsPromise;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            utils_1.assert(labels.rank === 1, 'labels must be a 1D tensor');
            utils_1.assert(predictions.rank === 1, 'predictions must be a 1D tensor');
            utils_1.assert(labels.size === predictions.size, 'labels and predictions must be the same length');

            if (weights != null) {
              utils_1.assert(weights.size === predictions.size, 'labels and predictions must be the same length');
            }

            labelsInt = labels.cast('int32');
            predictionsInt = predictions.cast('int32');

            if (numClasses == null) {
              numClasses = tfjs_1.tidy(function () {
                var max = tfjs_1.maximum(labelsInt.max(), predictionsInt.max()).cast('int32');
                return max.dataSync()[0] + 1;
              });
            }

            weightsPromise = Promise.resolve(null);

            if (weights != null) {
              weightsPromise = weights.data();
            }

            return _context2.abrupt("return", Promise.all([labelsInt.data(), predictionsInt.data(), weightsPromise]).then(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 3),
                  labelsArray = _ref4[0],
                  predsArray = _ref4[1],
                  weightsArray = _ref4[2];

              var result = Array(numClasses).fill(0);

              for (var i = 0; i < numClasses; i++) {
                result[i] = Array(numClasses).fill(0);
              }

              for (var _i = 0; _i < labelsArray.length; _i++) {
                var label = labelsArray[_i];
                var pred = predsArray[_i];

                if (weightsArray != null) {
                  result[label][pred] += weightsArray[_i];
                } else {
                  result[label][pred] += 1;
                }
              }

              return result;
            }));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.confusionMatrix = confusionMatrix;

function accuracy(labels, predictions) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var eq, mean, acc;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            utils_1.assertShapesMatch(labels.shape, predictions.shape, 'Error computing accuracy.');
            eq = labels.equal(predictions);
            mean = eq.mean();
            _context3.next = 5;
            return mean.data();

          case 5:
            acc = _context3.sent[0];
            tfjs_1.dispose([eq, mean]);
            return _context3.abrupt("return", acc);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.accuracy = accuracy;

function perClassAccuracy(labels, predictions, numClasses) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            utils_1.assert(labels.rank === 1, 'labels must be a 1D tensor');
            utils_1.assert(predictions.rank === 1, 'predictions must be a 1D tensor');
            utils_1.assert(labels.size === predictions.size, 'labels and predictions must be the same length');

            if (numClasses == null) {
              numClasses = tfjs_1.tidy(function () {
                return tfjs_1.maximum(labels.max(), predictions.max()).dataSync()[0] + 1;
              });
            }

            return _context4.abrupt("return", Promise.all([labels.data(), predictions.data()]).then(function (_ref5) {
              var _ref6 = _slicedToArray(_ref5, 2),
                  labelsArray = _ref6[0],
                  predsArray = _ref6[1];

              var counts = Array(numClasses).fill(0);
              var accuracy = Array(numClasses).fill(0);

              for (var i = 0; i < labelsArray.length; i++) {
                var label = labelsArray[i];
                var pred = predsArray[i];
                counts[label] += 1;

                if (label === pred) {
                  accuracy[label] += 1;
                }
              }

              var results = [];

              for (var _i2 = 0; _i2 < counts.length; _i2++) {
                results.push({
                  count: counts[_i2],
                  accuracy: counts[_i2] === 0 ? 0 : accuracy[_i2] / counts[_i2]
                });
              }

              return results;
            }));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.perClassAccuracy = perClassAccuracy;